export const numericInputStyles = {
  width: '100%',
};

export const LENGTH_PRODUCT_NAME = 70;
export const LENGTH_PRODUCT_DESCRIPTION = 250;

export const PLANOGRAM_IMAGE_TYPES = ['png', 'tiff', 'tif'];
const OTHER_IMAGES = ['jpeg', 'png', 'jpg', 'tiff', 'tif'];

export const MAX_NUMBER_INPUT_UPC = 9999999999999; // 14 digits

// Image ID Field Constants
export const FRONT_PLANOGRAM_IMAGE_ID = 'frontPlanogramImageId';
export const LEFT_PLANOGRAM_IMAGE_ID = 'leftPlanogramImageId';
export const RIGHT_PLANOGRAM_IMAGE_ID = 'rightPlanogramImageId';
export const BACK_PLANOGRAM_IMAGE_ID = 'backPlanogramImageId';
export const TOP_PLANOGRAM_IMAGE_ID = 'topPlanogramImageId';
export const BOTTOM_PLANOGRAM_IMAGE_ID = 'bottomPlanogramImageId';
export const FRONT_MARKETING_IMAGE_ID = 'frontMarketingImageId';
export const LEFT_MARKETING_IMAGE_ID = 'leftMarketingImageId';
export const RIGHT_MARKETING_IMAGE_ID = 'rightMarketingImageId';
export const PANEL_IMAGE_ID = 'panelImageId';
export const INGREDIENTS_IMAGE_ID = 'ingredientsImageId';
export const BARCODE_IMAGE_ID = 'barcodeImageId';
export const _2D_BARCODE_IMAGE_ID = '_2DBarcodeImageId';
export const OTHER_1_IMAGE_ID = 'other1ImageId';
export const OTHER_2_IMAGE_ID = 'other2ImageId';
export const OTHER_3_IMAGE_ID = 'other3ImageId';

export const DEFAULT_PRODUCT_IMAGERY = {
  [FRONT_PLANOGRAM_IMAGE_ID]: null,
  [LEFT_PLANOGRAM_IMAGE_ID]: null,
  [RIGHT_PLANOGRAM_IMAGE_ID]: null,
  [BACK_PLANOGRAM_IMAGE_ID]: null,
  [TOP_PLANOGRAM_IMAGE_ID]: null,
  [BOTTOM_PLANOGRAM_IMAGE_ID]: null,
  [FRONT_MARKETING_IMAGE_ID]: null,
  [LEFT_MARKETING_IMAGE_ID]: null,
  [RIGHT_MARKETING_IMAGE_ID]: null,
  [PANEL_IMAGE_ID]: null,
  [INGREDIENTS_IMAGE_ID]: null,
  [BARCODE_IMAGE_ID]: null,
  [_2D_BARCODE_IMAGE_ID]: null,
  [OTHER_1_IMAGE_ID]: null,
  [OTHER_2_IMAGE_ID]: null,
  [OTHER_3_IMAGE_ID]: null,
};

export const PRODUCT_IMAGERY_LABELS_BY_LEVEL = {
  Unit: {
    [FRONT_PLANOGRAM_IMAGE_ID]: 'Front C1N1',
    [LEFT_PLANOGRAM_IMAGE_ID]: 'Left C2N1',
    [RIGHT_PLANOGRAM_IMAGE_ID]: 'Right C8N1',
    [BACK_PLANOGRAM_IMAGE_ID]: 'Back C7N1',
    [TOP_PLANOGRAM_IMAGE_ID]: 'Top C3N1',
    [BOTTOM_PLANOGRAM_IMAGE_ID]: 'Bottom C9N1',
    [FRONT_MARKETING_IMAGE_ID]: 'Front Marketing C1C1',
    [LEFT_MARKETING_IMAGE_ID]: 'Left Marketing C1L1',
    [RIGHT_MARKETING_IMAGE_ID]: 'Right Marketing C1R1',
    [PANEL_IMAGE_ID]: 'Panel (L2, L5, L11, Etc)',
    [INGREDIENTS_IMAGE_ID]: 'Ingredients L4',
    [BARCODE_IMAGE_ID]: 'Linear Barcode L3',
    [_2D_BARCODE_IMAGE_ID]: 'Barcode L6',
    [OTHER_1_IMAGE_ID]: 'Other 1',
    [OTHER_2_IMAGE_ID]: 'Other 2',
    [OTHER_3_IMAGE_ID]: 'Other 3',
  },
  'Inner Pack': {
    [FRONT_PLANOGRAM_IMAGE_ID]: 'Front C1NB',
    [LEFT_PLANOGRAM_IMAGE_ID]: 'Left C2NB',
    [RIGHT_PLANOGRAM_IMAGE_ID]: 'Right C8NB',
    [BACK_PLANOGRAM_IMAGE_ID]: 'Back C7NB',
    [TOP_PLANOGRAM_IMAGE_ID]: 'Top C3NB',
    [BOTTOM_PLANOGRAM_IMAGE_ID]: 'Bottom C9NB',
    [FRONT_MARKETING_IMAGE_ID]: 'Front Marketing C1CB',
    [LEFT_MARKETING_IMAGE_ID]: 'Left Marketing C1LB',
    [RIGHT_MARKETING_IMAGE_ID]: 'Right Marketing C1RB',
    [PANEL_IMAGE_ID]: 'Panel (L2, L5, L11, Etc)',
    [INGREDIENTS_IMAGE_ID]: 'Ingredients L4',
    [BARCODE_IMAGE_ID]: 'Linear Barcode L3',
    [_2D_BARCODE_IMAGE_ID]: 'Barcode L6',
    [OTHER_1_IMAGE_ID]: 'Other 1',
    [OTHER_2_IMAGE_ID]: 'Other 2',
    [OTHER_3_IMAGE_ID]: 'Other 3',
  },
  Case: {
    [FRONT_PLANOGRAM_IMAGE_ID]: 'Front C1NA',
    [LEFT_PLANOGRAM_IMAGE_ID]: 'Left C2NA',
    [RIGHT_PLANOGRAM_IMAGE_ID]: 'Right C8NA',
    [BACK_PLANOGRAM_IMAGE_ID]: 'Back C7NA',
    [TOP_PLANOGRAM_IMAGE_ID]: 'Top C3NA',
    [BOTTOM_PLANOGRAM_IMAGE_ID]: 'Bottom C9NA',
    [FRONT_MARKETING_IMAGE_ID]: 'Front Marketing C1CA',
    [LEFT_MARKETING_IMAGE_ID]: 'Left Marketing C1LA',
    [RIGHT_MARKETING_IMAGE_ID]: 'Right Marketing C1RA',
    [PANEL_IMAGE_ID]: 'Panel (L2, L5, L11, Etc)',
    [INGREDIENTS_IMAGE_ID]: 'Ingredients L4',
    [BARCODE_IMAGE_ID]: 'Linear Barcode L3',
    [_2D_BARCODE_IMAGE_ID]: 'Barcode L6',
    [OTHER_1_IMAGE_ID]: 'Other 1',
    [OTHER_2_IMAGE_ID]: 'Other 2',
    [OTHER_3_IMAGE_ID]: 'Other 3',
  },
  'Display Shipper': {
    [FRONT_PLANOGRAM_IMAGE_ID]: 'Front C1NP',
    [LEFT_PLANOGRAM_IMAGE_ID]: 'Left C2NP',
    [RIGHT_PLANOGRAM_IMAGE_ID]: 'Right C8NP',
    [BACK_PLANOGRAM_IMAGE_ID]: 'Back C7NP',
    [TOP_PLANOGRAM_IMAGE_ID]: 'Top C3NP',
    [BOTTOM_PLANOGRAM_IMAGE_ID]: 'Bottom C9NP',
    [FRONT_MARKETING_IMAGE_ID]: 'Front Marketing C1CP',
    [LEFT_MARKETING_IMAGE_ID]: 'Left Marketing C1LP',
    [RIGHT_MARKETING_IMAGE_ID]: 'Right Marketing C1RP',
    [PANEL_IMAGE_ID]: 'Panel (L2, L5, L11, Etc)',
    [INGREDIENTS_IMAGE_ID]: 'Ingredients L4',
    [BARCODE_IMAGE_ID]: 'Linear Barcode L3',
    [_2D_BARCODE_IMAGE_ID]: 'Barcode L6',
    [OTHER_1_IMAGE_ID]: 'Other 1',
    [OTHER_2_IMAGE_ID]: 'Other 2',
    [OTHER_3_IMAGE_ID]: 'Other 3',
  },
  'Master Case': {
    [FRONT_PLANOGRAM_IMAGE_ID]: 'Front C1NM',
    [LEFT_PLANOGRAM_IMAGE_ID]: 'Left C2NM',
    [RIGHT_PLANOGRAM_IMAGE_ID]: 'Right C8NM',
    [BACK_PLANOGRAM_IMAGE_ID]: 'Back C7NM',
    [TOP_PLANOGRAM_IMAGE_ID]: 'Top C3NM',
    [BOTTOM_PLANOGRAM_IMAGE_ID]: 'Bottom C9NM',
    [FRONT_MARKETING_IMAGE_ID]: 'Front Marketing C1CM',
    [LEFT_MARKETING_IMAGE_ID]: 'Left Marketing C1LM',
    [RIGHT_MARKETING_IMAGE_ID]: 'Right Marketing C1RM',
    [PANEL_IMAGE_ID]: 'Panel (L2, L5, L11, Etc)',
    [INGREDIENTS_IMAGE_ID]: 'Ingredients L4',
    [BARCODE_IMAGE_ID]: 'Linear Barcode L3',
    [_2D_BARCODE_IMAGE_ID]: 'Barcode L6',
    [OTHER_1_IMAGE_ID]: 'Other 1',
    [OTHER_2_IMAGE_ID]: 'Other 2',
    [OTHER_3_IMAGE_ID]: 'Other 3',
  },
  Pallet: {
    [FRONT_PLANOGRAM_IMAGE_ID]: 'Front C1NP',
    [LEFT_PLANOGRAM_IMAGE_ID]: 'Left C2NP',
    [RIGHT_PLANOGRAM_IMAGE_ID]: 'Right C8NP',
    [BACK_PLANOGRAM_IMAGE_ID]: 'Back C7NP',
    [TOP_PLANOGRAM_IMAGE_ID]: 'Top C3NP',
    [BOTTOM_PLANOGRAM_IMAGE_ID]: 'Bottom C9NP',
    [FRONT_MARKETING_IMAGE_ID]: 'Front Marketing C1CP',
    [LEFT_MARKETING_IMAGE_ID]: 'Left Marketing C1LP',
    [RIGHT_MARKETING_IMAGE_ID]: 'Right Marketing C1RP',
    [PANEL_IMAGE_ID]: 'Panel (L2, L5, L11, Etc)',
    [INGREDIENTS_IMAGE_ID]: 'Ingredients L4',
    [BARCODE_IMAGE_ID]: 'Linear Barcode L3',
    [_2D_BARCODE_IMAGE_ID]: 'Barcode L6',
    [OTHER_1_IMAGE_ID]: 'Other 1',
    [OTHER_2_IMAGE_ID]: 'Other 2',
    [OTHER_3_IMAGE_ID]: 'Other 3',
  },
};

/* Based on the BE enum */
export const ACTIVE_PRODUCT_VALIDATE_IMAGERY_ERRORS = {
  [FRONT_PLANOGRAM_IMAGE_ID]: FRONT_PLANOGRAM_IMAGE_ID,
  [LEFT_PLANOGRAM_IMAGE_ID]: LEFT_PLANOGRAM_IMAGE_ID,
  [RIGHT_PLANOGRAM_IMAGE_ID]: RIGHT_PLANOGRAM_IMAGE_ID,
  [BACK_PLANOGRAM_IMAGE_ID]: BACK_PLANOGRAM_IMAGE_ID,
  [TOP_PLANOGRAM_IMAGE_ID]: TOP_PLANOGRAM_IMAGE_ID,
  [BOTTOM_PLANOGRAM_IMAGE_ID]: BOTTOM_PLANOGRAM_IMAGE_ID,
  [FRONT_MARKETING_IMAGE_ID]: FRONT_MARKETING_IMAGE_ID,
  [LEFT_MARKETING_IMAGE_ID]: LEFT_MARKETING_IMAGE_ID,
  [RIGHT_MARKETING_IMAGE_ID]: RIGHT_MARKETING_IMAGE_ID,
};

export const IMAGERY_TYPES = {
  [FRONT_PLANOGRAM_IMAGE_ID]: PLANOGRAM_IMAGE_TYPES,
  [LEFT_PLANOGRAM_IMAGE_ID]: PLANOGRAM_IMAGE_TYPES,
  [RIGHT_PLANOGRAM_IMAGE_ID]: PLANOGRAM_IMAGE_TYPES,
  [BACK_PLANOGRAM_IMAGE_ID]: PLANOGRAM_IMAGE_TYPES,
  [TOP_PLANOGRAM_IMAGE_ID]: PLANOGRAM_IMAGE_TYPES,
  [BOTTOM_PLANOGRAM_IMAGE_ID]: PLANOGRAM_IMAGE_TYPES,
  [FRONT_MARKETING_IMAGE_ID]: PLANOGRAM_IMAGE_TYPES,
  [LEFT_MARKETING_IMAGE_ID]: PLANOGRAM_IMAGE_TYPES,
  [RIGHT_MARKETING_IMAGE_ID]: PLANOGRAM_IMAGE_TYPES,
  [PANEL_IMAGE_ID]: OTHER_IMAGES,
  [INGREDIENTS_IMAGE_ID]: OTHER_IMAGES,
  [BARCODE_IMAGE_ID]: OTHER_IMAGES,
  [_2D_BARCODE_IMAGE_ID]: OTHER_IMAGES,
  [OTHER_1_IMAGE_ID]: OTHER_IMAGES,
  [OTHER_2_IMAGE_ID]: OTHER_IMAGES,
  [OTHER_3_IMAGE_ID]: OTHER_IMAGES,
};

export const PLANOGRAM_IMAGE_KEYS = [
  FRONT_PLANOGRAM_IMAGE_ID,
  LEFT_PLANOGRAM_IMAGE_ID,
  RIGHT_PLANOGRAM_IMAGE_ID,
  BACK_PLANOGRAM_IMAGE_ID,
  TOP_PLANOGRAM_IMAGE_ID,
  BOTTOM_PLANOGRAM_IMAGE_ID,
];

export const MARKETING_IMAGE_KEYS = [
  FRONT_MARKETING_IMAGE_ID,
  LEFT_MARKETING_IMAGE_ID,
  RIGHT_MARKETING_IMAGE_ID,
];

export const OTHER_IMAGE_KEYS = [
  PANEL_IMAGE_ID,
  INGREDIENTS_IMAGE_ID,
  BARCODE_IMAGE_ID,
  _2D_BARCODE_IMAGE_ID,
  OTHER_1_IMAGE_ID,
  OTHER_2_IMAGE_ID,
  OTHER_3_IMAGE_ID,
];

/*
This is a BE enum:
  BarcodeFormat.CODE_128,
  BarcodeFormat.CODE_39,
  BarcodeFormat.CODE_93,
  BarcodeFormat.EAN_13,
  BarcodeFormat.EAN_8,
  BarcodeFormat.UPC_A,
  BarcodeFormat.UPC_E,
  BarcodeFormat.QR_CODE,
  BarcodeFormat.DATA_MATRIX,
  BarcodeFormat.PDF_417,
  BarcodeFormat.AZTEC,
  BarcodeFormat.CODABAR,
  BarcodeFormat.ITF
*/
// This is a mapping type for using on FE
export const BARCODE_FORMAT = {
  GTIN: 'gtin',
  UPC_E: 'upc8',
  UPC_A: 'upc12',
  UPC_13: 'upc13',
};

// Define the priority order for sorting (lower number = higher priority)
export const BARCODE_FORMAT_PRIORITY = {
  GTIN: 1,
  UPC_E: 2, // UPC8
  UPC_A: 3, // UPC12
  UPC_13: 4, // UPC13
};

export const ACTIVE_PRODUCT_VALIDATION_ERRORS = [
  {
    fieldName: 'Gtin',
    errorMessage: 'GTIN is required.',
  },
  {
    fieldName: 'BrickCode',
    errorMessage: 'Brick Code is required.',
  },
  {
    fieldName: 'Width',
    errorMessage: 'Packaged Width is required.',
  },
  {
    fieldName: 'Height',
    errorMessage: 'Packaged Height is required.',
  },
  {
    fieldName: 'Depth',
    errorMessage: 'Packaged Depth is required.',
  },
  {
    fieldName: 'DimensionUOM',
    errorMessage: 'Packaged Dimension UOM is required.',
  },
  {
    fieldName: 'Weight',
    errorMessage: 'Packaged Weight is required.',
  },
  {
    fieldName: 'WeightUOM',
    errorMessage: 'Packaged Weight UOM is required.',
  },
];

export const RTA_FIELDS = [
  'unitCount',
  'productName',
  'productDescription',
  'primarySizeUOM',
  'primarySize',
  'height',
  'depth',
  'width',
  'weight',
  'weightUOM',
  'dimensionUOM',
  'netContentsStatement',
  'netContentsUom',
  'netContentsValue',
];

export const DEFAULT_UNIT_COUNT = 1;

export const DEFAULT_TARGET_MARKET = 'United States of America (the)';
